'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _class, _class2, _temp; /**
                                   * Created by zfc on 2017/6/26.
                                   */

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _reduxAsyncConnect = require('redux-async-connect');

var _background = require('redux/modules/background');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShopRegisterProtocol = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var dispatch = _ref.store.dispatch;

    var promises = [];
    promises.push(dispatch((0, _background.changeHeaderText)('艺品商入驻协议')));
    return _promise2.default.all(promises);
  }
}]), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ShopRegisterProtocol, _Component);

  function ShopRegisterProtocol() {
    (0, _classCallCheck3.default)(this, ShopRegisterProtocol);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(ShopRegisterProtocol).call(this));
  }

  (0, _createClass3.default)(ShopRegisterProtocol, [{
    key: 'render',
    value: function render() {
      var styles = require('./ShopRegisterProtocol.scss');
      var carouselOfContactUsTitle = [{
        img: 'http://tupian.goeasy.cn:9999/yipinwang/main/01.jpg'
      }, {
        img: 'http://tupian.goeasy.cn:9999/yipinwang/main/02.jpg'
      }, {
        img: 'http://tupian.goeasy.cn:9999/yipinwang/main/03.jpg'
      }];
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.tackImg },
          _react2.default.createElement(_components.GoeasyCarousel, { page: 'productsListMiddle', style: { width: 1280, height: 213 },
            images: carouselOfContactUsTitle })
        ),
        _react2.default.createElement(
          'div',
          { className: styles.rightContent },
          _react2.default.createElement('div', { className: 'clear' }),
          _react2.default.createElement(
            'h1',
            { className: styles.protocolTitle },
            '艺品网商户入驻协议'
          ),
          _react2.default.createElement(
            'div',
            { className: styles.content },
            _react2.default.createElement(
              'div',
              { className: styles.protocolContent },
              _react2.default.createElement(
                'p',
                null,
                '甲方：中艺互联商务科技（北京）股份有限公司'
              ),
              _react2.default.createElement(
                'p',
                null,
                '地址：北京市丰台区南四环西路188号一区15号楼三层'
              ),
              _react2.default.createElement(
                'p',
                null,
                '乙方：'
              ),
              _react2.default.createElement(
                'p',
                null,
                '地址：'
              ),
              _react2.default.createElement(
                'p',
                null,
                '1.甲方为依法设立的股份有限公司，并依法运营管理“艺品网”。'
              ),
              _react2.default.createElement(
                'p',
                null,
                '2.乙方为依法设立的公司（大师工作室、个体商户），希望与甲方合作并通过“艺品网”销售其产品。'
              ),
              _react2.default.createElement(
                'p',
                null,
                '据此，根据国家有关法律、法规的规定，本着平等、诚信、自愿的原则，经充分协商，甲乙双方就合作事宜达成如下协议：'
              ),
              _react2.default.createElement(
                'h3',
                null,
                '第一章 总则'
              ),
              _react2.default.createElement(
                'p',
                null,
                '为全面贯彻落实党中央大力发展文化产业，推动中国文化走向世界的方针政策，以艺品网为工美行业基本平台，中国工艺美术协会打造全国工美行业第一保真，第一品质，第一服务，整合优质资源的互联网平台，促进中国工艺美术行业顺利转型，为中国工艺美术产业大发展、大繁荣做出贡献。'
              ),
              _react2.default.createElement(
                'h3',
                null,
                '第二章 权利及义务'
              ),
              _react2.default.createElement(
                'p',
                null,
                'A．乙方权利及义务'
              ),
              _react2.default.createElement(
                'p',
                null,
                '1.乙方保证在艺品网上所销售商品的合法性，并对所提供的所有产品及服务承担所有责任，包括并不仅限于知识产权、产品质量等。'
              ),
              _react2.default.createElement(
                'p',
                null,
                '2.乙方负责制定网上合作平台的产品零售指导价格。为了促进商品销售，甲方举办各种宣传推广活动（包括各种媒体的广告宣传、展览、表演、赠品等），乙方应全力配合。甲方让利打折期间，乙方应承担价格折扣，具体细节甲乙双方另行协商并签订补充协议作为本合同的补充条款。'
              ),
              _react2.default.createElement(
                'p',
                null,
                '3.乙方负责提供网上合作平台所售商品并保证稳定的库存。'
              ),
              _react2.default.createElement(
                'p',
                null,
                '4.乙方应按甲方要求主动向甲方提供网上合作平台所需要的有关产品图片、信息、介绍、市场及宣传等文档内容。'
              ),
              _react2.default.createElement(
                'p',
                null,
                '5.乙方保证接受并严格遵守甲方对网上平台销售商品的管理，并保证商品外形美观、器形端正、花色图案清晰；商品要有外包装盒，包装盒必须有利于保护商品完整、安全、销售及适于长途运输；包装盒的设计、形状、图案等权利没有违反或侵犯他人的知识产权（包括商标、版权、外观设计、名称、专利）；乙方承诺不存在其他任何第三方权益或其他任何权利限制。根据商品类型，乙方负责提供商品相关证明资料，包括但不限于收藏证书、鉴定证书、获奖证书、精品创作背景、质检证明、商品介绍、监制单位的证明等；乙方有义务依据艺品网所制定规则针对销售的工艺品及相关服务进行三包政策和退换货处理。所退换的产品不影响二次销售。'
              ),
              _react2.default.createElement(
                'p',
                null,
                '6.乙方保证在甲方销售产品价格不得高于给其他销售渠道的价格。'
              ),
              _react2.default.createElement(
                'p',
                null,
                '7.根据消费者要求，乙方负责提供所销售商品的正式发票。'
              ),
              _react2.default.createElement(
                'p',
                null,
                'B. 甲方的权利及义务'
              ),
              _react2.default.createElement(
                'p',
                null,
                '1.甲方拥有网上平台的后台信息系统、操作规范等的知识产权。'
              ),
              _react2.default.createElement(
                'p',
                null,
                '2.乙方应确保甲方运营的网上平台的信息系统性能满足合作需要的技术规范。'
              ),
              _react2.default.createElement(
                'p',
                null,
                '3.甲方负责网上平台的网站设计、网站运营、网站推广、电话客服。'
              ),
              _react2.default.createElement(
                'h3',
                null,
                '第三章 网站建设费及收益分配'
              ),
              _react2.default.createElement(
                'p',
                null,
                '1.乙方须向消费者开具商品销售发票。(根据客户需求确定开否)'
              ),
              _react2.default.createElement(
                'p',
                null,
                '2.甲方作为乙方产品的展示、销售平台，有权按照本协议项下约定收取乙方一定的平台使用费。'
              ),
              _react2.default.createElement(
                'p',
                null,
                '3.配送与结算'
              ),
              _react2.default.createElement(
                'p',
                null,
                '3.1乙方将按照《中华人民共和国产品质量法》、《中华人民共和国消费者权益保护法》及其它法规、部门规章和国家强制性标准的规定，负责商品的配送，并承担商品配送过程中的风险和费用。乙方通过甲方平台售出的商品，由甲方代表乙方为购买用户完成上述售后服务。'
              ),
              _react2.default.createElement(
                'p',
                null,
                '3.2双方以自然月为对帐结算周期，乙方次月5日前将上月对帐单发给甲方财务进行上一对帐周期对帐，甲方在收到乙方对帐通知单5个工作日内，将上个月乙方产品在甲方平台销售清单回执给乙方。'
              ),
              _react2.default.createElement(
                'p',
                null,
                '3.3双方以当月甲方平台销售清单做为结算对账单。如甲方对乙方提供的对帐单有异议，双方可通过对帐方式进行核对。双方对结算对帐单确认无误后5个工作日内，甲方应在每月20日前向乙方帐户汇入双方确认的上月结算金额。'
              ),
              _react2.default.createElement(
                'h3',
                null,
                '第四章 平台使用费'
              ),
              _react2.default.createElement(
                'p',
                null,
                '1.乙方可以使用甲方平台系统。电商平台管理系统，在前台可帮助企业整理店面，在后台按商家要求设立商店管理员权限，为商家在网上管理商店提供条件和工具。'
              ),
              _react2.default.createElement(
                'p',
                null,
                '2.平台使用费为人民币陆仟元/年（按合同生效之日起一个自然年计算）。'
              ),
              _react2.default.createElement(
                'p',
                null,
                '3.乙方首次平台使用费应于合同生效后 7 日内交付，此后每年应在合同到期前 15 日内足额交付。'
              ),
              _react2.default.createElement(
                'h3',
                null,
                ' 第五章 诚信保证金'
              ),
              _react2.default.createElement(
                'p',
                null,
                '1.甲乙双方基于诚信互惠的原则，根据产品不同类别，乙方交付诚信保证金陆万元（6万元），并且乙方同意甲方有权根据实际情况调增或调减上述保证金额度，乙方予以配合。'
              ),
              _react2.default.createElement(
                'p',
                null,
                '1.1乙方在甲方平台销售业绩与信用评价良好，甲方有权根据实际情况，适度调减保证金额度。'
              ),
              _react2.default.createElement(
                'p',
                null,
                '1.2乙方在甲方平台出现包括但不仅限于销售假冒伪劣产品，虚假宣传，出售国家明令禁止产品，不正当交易等违规行为，甲方有权根据实际情况调增保证金额度。'
              ),
              _react2.default.createElement(
                'p',
                null,
                '2.为了保护消费者的利益，消费者因乙方的违约行为而受到损害时，可根据艺品网规则从保证金中扣除相应额度来抵销消费者所产生的经济损失，保证金不够赔偿时，乙方应追加补足赔付。'
              ),
              _react2.default.createElement(
                'p',
                null,
                '3.诚信保证期自本合同生效之日起至甲乙双方合同期满或自合同生效之日起至达成艺品网相应保证金管理规则及信用评级规则中的退保要求，甲方直接将诚信保证金（无息）划回乙方账户。'
              ),
              _react2.default.createElement(
                'h3',
                null,
                '第六章 认证服务费'
              ),
              _react2.default.createElement(
                'p',
                null,
                '1.甲方秉承艺品网“真人、真店、真品”的原则，对乙方进行资质的审核，其中包括不限于企业工商、税务、财务资质、法人身份信息、企业信息、产品质量信息；大师的身份信息，职称与用于称号资质、产品质量信息进行审核，乙方需向甲方一次性交付认证服务费（大写）伍仟元。'
              ),
              _react2.default.createElement(
                'p',
                null,
                '2.乙方根据艺品网认证规则，应向甲方提供认证所需信息。'
              ),
              _react2.default.createElement(
                'p',
                null,
                ' 3.乙方认证服务费自合同生效起15个工作日内交付。'
              ),
              _react2.default.createElement(
                'h3',
                null,
                '第七章 交易佣金'
              ),
              _react2.default.createElement(
                'p',
                null,
                ' 1.乙方在艺品网经营需要按照其销售额的一定百分比(简称“费率”)交纳的费用。'
              ),
              _react2.default.createElement(
                'p',
                null,
                '2.上述交易佣金由甲方在每成功交易时自动扣取的费用。'
              ),
              _react2.default.createElement(
                'p',
                null,
                '3.交易佣金费率根据产品部同类别为15%。'
              ),
              _react2.default.createElement(
                'h3',
                null,
                '第八章 商业保密条款'
              ),
              _react2.default.createElement(
                'p',
                null,
                '1.商业秘密：任何一方公开或未公开的任何技术信息和经营信息，包括但不限于：产品计划、销售计划、奖励政策、客户资料、财务信息等，以及非专利技术、设计、程序、技术数据、制作方法、资讯来源等，均构成该方的商业秘密。'
              ),
              _react2.default.createElement(
                'p',
                null,
                '2.保密：双方对在本协议下知悉的另一方的任何商业秘密均负有保密义务，任何一方在任何时候均不得向第三方披露另一方的商业秘密，非经另一方书面许可不得向任何第三方泄露。任何一方违反本条规定的，应全额赔偿另一方因此遭受的全部直接和间接损失。'
              ),
              _react2.default.createElement(
                'p',
                null,
                '3.本协议终止后至少3年内，双方仍然负有本条款项下规定的保密义务。'
              ),
              _react2.default.createElement(
                'h3',
                null,
                '第九章优惠政策'
              ),
              _react2.default.createElement(
                'p',
                null,
                '为更好的服务于中国工艺美术行业，为大师、企业及广大从业者提供更加广阔的电子商务平台，甲方针对首批上线大师及企业提供相应的优惠政策。'
              ),
              _react2.default.createElement(
                'p',
                null,
                '1.首批上线大师和企业免认证费、诚信保证金、平台使用费。'
              ),
              _react2.default.createElement(
                'p',
                null,
                '2.乙方在交易中如发生违规及不限于出售假冒伪劣产品等行为，产生的一切费用均由乙方自行承担。'
              ),
              _react2.default.createElement(
                'h3',
                null,
                '第十章 违约责任'
              ),
              _react2.default.createElement(
                'p',
                null,
                '1.甲乙双方任何一方严重违反本协议，造成本合同约定的合作业务无法经营或由于一方不履行本协议规定的义务、经通知纠正后15日内仍未纠正的，视作根本违约，守约方有权解除本协议。如双方同意继续合作，违约方仍应赔偿守约方的经济损失。'
              ),
              _react2.default.createElement(
                'p',
                null,
                '2.甲方保证所提供的技术设备的正常运作，如因甲方单方技术设备原因给消费者造成相关损失，由甲方承担责任。'
              ),
              _react2.default.createElement(
                'p',
                null,
                '3.甲方因本合作协议在互联网销售乙方产品并不意味因此获得销售产品所涉及的一方知识产权。甲方未经乙方书面许可，不得就销售产品涉及的知识产权擅自使用、制作或允许第三人使用。如违反本条规定，乙方有权解除本合同，由此给乙方造成损失的，乙方有权向甲方追偿。'
              ),
              _react2.default.createElement(
                'p',
                null,
                '4.乙方承诺所提供商品未违反任何法律法规或侵犯他人的任何合法权利，不存在任何安全隐患，严格依法销售商品，乙方自行妥善处理与商品消费者发生的产品质量以外的任何纠纷；乙方提供的商品，被消费者投诉、被工商、技术监督、物价、公安等政府主管部门处罚或被新闻媒体曝光的，乙方除应承担对消费者的赔偿外，还需承担甲方由此支出的一切费用。'
              ),
              _react2.default.createElement(
                'p',
                null,
                '5．因任何原因导致甲乙双方终止合作时，甲方暂留未结算货款3个月，用于解决协议期及暂留货款期间，出现产品质量纠纷及违约的索赔。甲方有权以该款支付索赔（不足部分乙方须补缴差额），3个月后甲方将余款退还乙方。'
              ),
              _react2.default.createElement(
                'p',
                null,
                '6.如因为不可抗力导致技术故障，进而影响服务的不能履行或履行延误，从而导致消费者理解错误而造成的任何损失，双方均不负责任。'
              ),
              _react2.default.createElement(
                'p',
                null,
                '7.不可抗力：在合作期间，由于地震、台风、水灾、火灾、战争或其他不能预见并且对其发生和后果不能防止和避免的不可抗力事故，致使协议的履行直接被影响或者不能按约定的条件履行时，遇有上述不可抗力事故的一方，应立即将事故情况通知对方，并应在十五天内提供事故的详细情况及协议不能履行、或者部分不能履行、或者需要延期履行的理由的有效证明文件。按照事故对协议的履行的影响程度，由双方协商决定是否解除协议、或者部分免除履行协议的责任、或者延期履行协议。'
              ),
              _react2.default.createElement(
                'h3',
                null,
                '第十一章 协议的生效、终止及其他'
              ),
              _react2.default.createElement(
                'p',
                null,
                '1.本协议自双方盖章之日起正式生效。协议期满前一个月若双方均未以书面形式提出异议，则本协议自动延期一年，延期期数没有限制，直到双方提出异议为止。'
              ),
              _react2.default.createElement(
                'p',
                null,
                '2.若本合同终止或解除后双方不再续签新的合同的，则甲方应在本合同终止或解除后的7日内清除完毕网站上的所有品牌标志和广告宣传，并将乙方产品和其它属于乙方的财产完好地归还乙方。并且，甲方不得向乙方收取任何费用。'
              ),
              _react2.default.createElement(
                'p',
                null,
                '3.对本协议内容做出的任何修改和补充应为书面形式，由双方盖章后成为协议不可分割的部分。'
              ),
              _react2.default.createElement(
                'p',
                null,
                '4.本协议及其附件为中文本，共两份原件，均具同等法律效力，双方各执一份为凭。'
              ),
              _react2.default.createElement(
                'p',
                null,
                '5.本协议未尽事宜，须经双方另行协商并签署书面文件，与本协议具有同等法律效力。本合同在履行过程中发生争议，由双方当事人协商解决；协商不成的，双方同意在甲方所在地有管辖权的人民法院诉讼解决。'
              ),
              _react2.default.createElement(
                'p',
                null,
                '6.对协议及附件的任何变更或修改均以书面形式确认，并需甲乙双方或其授权代表签字、盖章方为有效。'
              )
            )
          ),
          _react2.default.createElement(
            'a',
            { className: styles.btn, href: 'http://tupian.goeasy.cn:9999/yipinwang/%e4%b8%ad%e5%9b%bd%e8%89%ba%e5%93%81%e7%bd%91%e5%95%86%e6%88%b7%e5%85%a5%e9%a9%bb%e5%8d%8f%e8%ae%ae.pdf',
              download: '艺品网商户入驻协议' },
            '点击下载'
          )
        ),
        _react2.default.createElement('div', { className: 'clear' })
      );
    }
  }]);
  return ShopRegisterProtocol;
}(_react.Component), _class2.propTypes = {
  children: _react.PropTypes.object,
  location: _react.PropTypes.object
}, _temp)) || _class);
exports.default = ShopRegisterProtocol;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/ShopRegisterProtocol/ShopRegisterProtocol.js
 ** module id = 1547
 ** module chunks = 0
 **/